export class CalculateDestination {
  service: string;
  action: string;

  constructor(service: string, action: string) {
    this.service = service;
    this.action = action;
  }
}
